export default "/assets/images/mila-feed-07.47fe5b6e44298b95.mp4";